angular.module('gym.contacts').directive('editBrivoCredential', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/contacts/access_control/edit_brivo_credential.html.slim'),
    scope: {
      contact: '=',
      cancel: '&'
    },
    controller: ["$scope", "$state", "$stateParams", "$http", "loadingAnimation", function($scope, $state, $stateParams, $http, loadingAnimation) {
      var gymUrl;
      $scope.selectedCredential = {};
      gymUrl = `/gyms/${$stateParams.gymId}`;
      $scope.loadCredentials = function(refresh) {
        var refreshParam, url;
        loadingAnimation.show();
        refreshParam = refresh ? "&refresh=1" : "";
        url = `${gymUrl}/access_control/credentials?count=10000${refreshParam}`;
        return $http.get(url).then(function(response) {
          loadingAnimation.hide();
          return $scope.options = response.data.collection;
        }, function() {
          return loadingAnimation.hide();
        });
      };
      $scope.loadCredentials();
      return $scope.save = function() {
        var contactId, id, params, type, url;
        loadingAnimation.show();
        type = $stateParams.contactType;
        contactId = $stateParams.contactId;
        id = $scope.selectedCredential.id;
        url = `${gymUrl}/${type}/${contactId}/brivo_credentials/${id}`;
        params = {
          contact_brivo_credential: {
            sync_member_number_value_on_save: false
          }
        };
        return $http.put(url, params).then(function() {
          return $scope.cancel();
        }, function() {
          return loadingAnimation.hide();
        });
      };
    }]
  };
});
